import { api } from 'webReservations/api';

export const getAvailableDatesForRestaurant = async (
  restaurantId: string,
): Promise<string[]> => api.get(`/restaurants/${restaurantId}/available-dates`);
